module.exports = __webpack_public_path__ + "static/media/vehicle-type-car-green.4ca461e6.svg";